module.exports = __webpack_public_path__ + "img/bl.1ecc77cb.svg";